// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export enum ConflictResolutionMode {
  Custom = "Custom",
  LastWriterWins = "LastWriterWins",
}
